import HeaderFooterLayout from 'layouts/HeaderFooterLayoutAdmin';
import React from 'react';
import AdminLogin from '../components/AdminPanel/Login';

const AdminLoginPage = ({ ...props }) => {
  return (
    <div>
      <HeaderFooterLayout>
        <AdminLogin {...props} />
      </HeaderFooterLayout>
    </div>
  );
};

export default AdminLoginPage;
